const baseURL = "http://agsift-image-analysis.ap-south-1.elasticbeanstalk.com"
// const baseURL = "http://192.168.1.4:9000"

import Axios from 'axios'
export default {
  actions: {
    getAllVisualAnalysisReports({ commit }) {
      // commit("getAllVisualAnalysisReports", [
      //     {
      //         "commodity": "potato",
      //         "inspection_date": "2020-05-08T12:57:40.262",
      //         "id": "5eb5574ef8b5530d64940a5d"
      //     }
      // ])
      // commit('showLoader', false)

      commit('showLoader', true)

      return new Promise((resolve, reject) => {
        Axios.get(`${baseURL}/predict`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        })
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              return reject()
            }
            commit("getAllVisualAnalysisReports", resp.data.data)
            return resolve()
          }).catch(err => {
            commit('showSnackbar', {
              msg: err
            })
            return reject()
          })
          .finally(() => {
            console.log("finally");

            commit('showLoader', false)
          })
      })
    },
    getVisualAnalysisReport({ commit }, { commodity, id }) {

      commit('showLoader', true)

      return new Promise((resolve, reject) => {
        Axios.get(`${baseURL}/predict/${commodity}/${id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        })
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit("getVisualAnalysisReport", {})
              return reject()
            }
            commit("getVisualAnalysisReport", resp.data.data)
            resolve()

          }).catch(err => {
            commit('showSnackbar', {
              msg: err
            })
            commit("getVisualAnalysisReport", {})
            return reject()
          })
          .finally(() =>
            commit('showLoader', false)
          )
      })
    },

    uploadVisualAnalysisReport({ commit },{commodity,inspection_date,file}) {
      let formData = new FormData();
      formData.append('image',file)
      formData.append('inspection_date',inspection_date)
      commit("showLoader",true)
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        Axios.post(`${baseURL}/predict/${commodity}`, formData, config)
        .then(resp => {
          if (resp.data.error) {
            commit('showSnackbar', {
              msg: resp.data.msg
            })
            commit("getVisualAnalysisReport", {})
            return reject()
          }
          commit("getVisualAnalysisReport", resp.data.data)
          resolve()

        }).catch(err => {
          commit('showSnackbar', {
            msg: err
          })
          commit("getVisualAnalysisReport", {})
          return reject()
        })
        .finally(() =>
          commit('showLoader', false)
        )
      })

    },

    getVisualAnalysisCommodities({ commit }) {
      commit('showLoader', true)

      return new Promise((resolve, reject) => {
        Axios.get(`${baseURL}/commodities`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        })
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit("getVisualAnalysisCommodities", [])
              return reject()
            }
            commit("getVisualAnalysisCommodities", resp.data.data)
            resolve()

          }).catch(err => {
            commit('showSnackbar', {
              msg: err
            })
            commit("getVisualAnalysisCommodities", [])
            return reject()
          })
          .finally(() =>
            commit('showLoader', false)
          )
      })
    },

  },
  mutations: {
    getAllVisualAnalysisReports(state, data) {
      state.VisualAnalysis = {
        ...state.VisualAnalysis,
        reports: data
      }
    },
    getVisualAnalysisReport(state, data) {
      state.VisualAnalysis = {
        ...state.VisualAnalysis,
        report: data
      }
    },
    getVisualAnalysisCommodities(state, data) {
      state.VisualAnalysis = {
        ...state.VisualAnalysis,
        commodities: data
      }
    }
  }
}